import { connect } from "react-redux";
import { IDType, MatchSmallElement } from "../../../config/types";
import { MatchScreen } from "../../../client/api";
import { AppDispatch, RootState } from "../../../store";
import { fetchMatchScreen } from "../../../store/actions/matchActions";
import { makeSelectFullMatchById, selectMatchStatus, selectIsMatchScreenLoaded } from "../../../selectors";

const mapper = (dispatch: AppDispatch) => ({
  loadMatchScreen: (id: IDType) => fetchMatchScreen(dispatch, id),
});

const getMatchIdFromPath = (): number => {
  const m = window.location.pathname.match(/match\/(\d+)/);
  if (!m) return -1;
  const id = parseInt(m[1], 10);
  return Number.isNaN(id) ? -1 : id;
};

const props = (
  state: RootState,
  prevProps: { match?: MatchSmallElement }
) => {
  const fallbackId = getMatchIdFromPath();
  const thisMatchId = prevProps?.match?.id ?? fallbackId;
  const isScreenLoaded = thisMatchId !== -1 ? selectIsMatchScreenLoaded(thisMatchId)(state) : false;
  const matchStatus = selectMatchStatus(state);
  return {
    fullMatch: makeSelectFullMatchById(thisMatchId)(state),
    screenFromStore: state.match.matchScreens?.[thisMatchId]?.response as MatchScreen | undefined,
    thisMatchId,
    isLoading: matchStatus === "loading" && !isScreenLoaded,
    ...prevProps,
  };
};

export const connector = connect(props, mapper);
